import apiClient from "./index";

// 회원 전체 목록 캐시 — 회원 선택 모달을 열 때마다 전체 조회가 반복되는 것을 방지
const MEMBERS_CACHE_TTL_MS = 5 * 60 * 1000;
let cachedMembers = null;
let cachedMembersAt = 0;

// 포인트 잔액이 바뀌는 시점(결제 성공 등)에 호출하여 신선도를 보장
export const invalidateMembersCache = () => {
  cachedMembers = null;
  cachedMembersAt = 0;
};

// 회원 목록 조회 (5분 TTL 캐시)
// 사본을 반환한다 — 소비처의 제자리 정렬(sort)이 캐시 원본을 변형하지 않도록
export const fetchMembers = async () => {
  if (cachedMembers && Date.now() - cachedMembersAt < MEMBERS_CACHE_TTL_MS) {
    return [...cachedMembers];
  }
  try {
    const response = await apiClient.get("/members");
    cachedMembers = response.data;
    cachedMembersAt = Date.now();
    return [...cachedMembers];
  } catch (error) {
    console.error("Failed to fetch members:", error.response?.data || error.message);
    throw error;
  }
};

// 특정 회원 정보 조회
// 회원 이름 변경 (관리자 전용). 인자는 account_id — memberId(members.id)와 혼동 금지.
// 이름이 목록 캐시에도 들어있으므로 성공 시 캐시를 비운다.
export const changeMemberName = async (accountId, name) => {
  try {
    const response = await apiClient.patch(`/members/${accountId}/name`, { name });
    invalidateMembersCache();
    return response.data;
  } catch (error) {
    console.error("❌ 회원 이름 변경 실패:", error.response?.data?.message || error.message);
    throw error;
  }
};

export const fetchMemberInfo = async (memberId) => {
  try {
    const response = await apiClient.get(`/members/${memberId}`);
    return response.data;
  } catch (error) {
    console.error(`Failed to fetch member ${memberId}:`, error.response?.data || error.message);
    throw error;
  }
};

// 포인트 업데이트
export const updateMemberPoints = async (memberId, points, reason) => {
  try {
    const response = await apiClient.patch(`/members/${memberId}/points`, {
      points,
      reason,
    });
    return response.data;
  } catch (error) {
    console.error(`Failed to update points for member ${memberId}:`, error.response?.data || error.message);
    throw error;
  }
};

// ✅ 회원의 거래 내역 조회 (추가)
export const fetchMemberTransactions = async (memberId) => {
  console.log("🔥 fetchMemberTransactions 함수 실행됨!", memberId);
  try {
    console.log("🚀 요청 보냄: /members/" + memberId + "/transactions");
    const response = await apiClient.get(`/members/${memberId}/transactions`);
    return response.data;
  } catch (error) {
    console.error(`Failed to fetch transactions for member ${memberId}:`, error.response?.data || error.message);
    return [];
  }
};

// ✅ 미수금 고객 조회 API
export const fetchArrearMembers = async () => {
  try {
    const response = await apiClient.get("/members/arrears");
    console.log("fetchArrearMembers response:", response.data);
    return response.data;
  } catch (error) {
    console.error("❌ 미수금 회원 조회 실패:", error.response?.data || error.message);
    return [];
  }
};

export const payArrears = async (memberId, paymentMethod) => {
  try {
    const response = await apiClient.patch(`/members/${memberId}/pay-arrears`, { payment_method: paymentMethod });
    console.log("payArrears response:", response.data);
    return response.data;
  } catch (error) {
    console.error("❌ 미수금 결제 실패:", error.response?.data || error.message);
    return null;
  }
};

// export const fetchMyPageData = async (accountId) => {
//   if (!accountId) {
//     console.error("❌ fetchMyPageData 호출 실패: accountId가 없습니다!");
//     return null;
//   }
//   console.log("🔥 fetchMyPageData 함수 실행됨!", accountId);
//   try {
//     const response = await apiClient.get(`/members/mypage/${accountId}`);
//     console.log("✅ fetchMyPageData 응답:", response.data); // ✅ 응답 확인
//     if (response.data.member) {
//       console.log("🛠 회원 정보:", response.data.member);
//     }

//     if (response.data.transactions) {
//       console.log("🚀 거래 내역 데이터 있음:", response.data.transactions);
//       console.log("🔥 fetchMemberTransactions 함수 실행됨!", accountId);
//     }
//     return response.data;
//   } catch (error) {
//     console.error("❌ MyPage 데이터 불러오기 실패:", error.response?.data || error.message);
//     return null;
//   }
// };
export const fetchMyPageData = async (accountId) => {
  if (!accountId) {
    console.error("❌ fetchMyPageData 호출 실패: accountId가 없습니다! (전달된 값:", accountId, ")");
    return null;
  }

  console.log("🔥 fetchMyPageData 함수 실행됨! accountId:", accountId);
  try {
    const response = await apiClient.get(`/members/mypage/${accountId}`);
    console.log("✅ fetchMyPageData 응답:", response.data);
    return response.data;
  } catch (error) {
    console.error("❌ MyPage 데이터 불러오기 실패:", error.response?.data || error.message);
    return null;
  }
};